export const ConvoyPermission = 'DoctorConvoy';
export const HIVDoctorPermission = 'HIVDoctor';
export const HIVAssistantPermission = 'HIVAssistant';
export const HIVPharmacistPermission = 'HIVPharmacist';
export const ConventinXRPermission = 'ConventinXR';
export const IraqiDoctorPermission = 'IraqiDoctor';
export const DoctorAssistantPermission = 'DoctorAssistant';
export const DoctorCarnivitaPermission = 'DoctorCarnivita';
export const DoctorEsomeprazolePermission = 'DoctorEsomeprazole';
export const GenuphilPermission = 'Genuphil';
export const RocheDoctorPermission = 'RocheDoctor';
export const NormalDoctorPermission = 'NormalDoctor';
export const TreatmentLinesPermission = 'TreatmentLines';

export const permissions = [
  ConvoyPermission,
  HIVDoctorPermission,
  HIVAssistantPermission,
  HIVPharmacistPermission,
  ConventinXRPermission,
  IraqiDoctorPermission,
  DoctorAssistantPermission,
  DoctorCarnivitaPermission,
  DoctorEsomeprazolePermission,
  GenuphilPermission,
  RocheDoctorPermission,
  NormalDoctorPermission,
  TreatmentLinesPermission
];

